import { jsxs, jsx } from "react/jsx-runtime";
import { LAYOUT } from "./constants.js";
const HEADER_BACKGROUND_EXTRA_PX = 8;
function PageHeader({ isEven, bleedPx = 0 }) {
  const curveBottom = -bleedPx - HEADER_BACKGROUND_EXTRA_PX - 1;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "relative w-full",
      style: {
        height: LAYOUT.header.totalHeight,
        overflow: "visible"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "aria-hidden": "true",
            style: {
              position: "absolute",
              inset: 0,
              height: LAYOUT.header.totalHeight + bleedPx + HEADER_BACKGROUND_EXTRA_PX,
              background: "#FEF1CB"
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              bottom: curveBottom,
              left: isEven ? 0 : bleedPx,
              right: isEven ? bleedPx : 0,
              height: LAYOUT.header.curveHeight + 1,
              background: "#ffffff",
              ...isEven ? { borderTopRightRadius: LAYOUT.header.curveHeight } : { borderTopLeftRadius: LAYOUT.header.curveHeight }
            }
          }
        )
      ]
    }
  );
}
export {
  PageHeader
};
//# sourceMappingURL=PageHeader.js.map
